<div class="detail-row subtab-wrapper">
    <p-tabView [(activeIndex)]="invActiveIndex" (onChange)="onTabChange($event)" class="custom-tablist custom-subtablist" [ngClass]="{'subtab-rightmenu': (['Shipping','Payment Method','Payment Term'].includes(selectedTabHeader) && selectedAccount.statusId==1)}" [scrollable]="true">
        <p-tabPanel header="Shipping">
            <p-table [value]="shipMethods" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Is Active</th>
                        <th>Is Default</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-ship>
                    <tr>
                        <td>{{ship.shippingMethod?.name}}</td>
                        <td>{{ship.statusId==1? 'Yes' : "No"}}</td>
                        <td>
                            <p-radioButton [disabled]="ship.statusId==2" [value]="true" [(ngModel)]="ship.isDefault"
                                (onClick)="makeDefault(ship,shipMethods,'shipping')"></p-radioButton>
                            {{ship.isDefault ? 'Yes' : 'No'}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td colspan="7" class="p-text-center">
                            No Data found.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Payment Method">
            <ng-container *ngFor="let data of accountPaymentMethodLists; let i = index;">
                <h6>{{data.paymentMethodName}} <span class="p-ml-1">({{data?.count}})</span> <span
                        *ngIf="data.isDefault"> - (Preferred)</span>
                    <ng-container *ngIf="selectedAccount.statusId !==2">
                        <span class="btnBars" style="float: right;margin-right: 25px;" (click)="showAddPMPopup()"
                            *ngIf="i==0">
                            <i class="pi pi-plus"></i>
                        </span>
                    </ng-container>
                </h6>

                <p-table [value]="data.accountPaymentMethodSubDetail" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th>Is Active</th>
                            <th>Is Default</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-method>
                        <tr>
                            <td>{{method.displayName}}</td>
                            <td>{{method.statusId==1? 'Yes' : "No"}}</td>
                            <td>
                                <p-radioButton [disabled]="method.statusId==2 || selectedAccount.statusId ===2"
                                    [value]="true" [(ngModel)]="method.isDefault"
                                    (onClick)="makeDefault(method,data.accountPaymentMethodSubDetail,'paymentmethod')"></p-radioButton>
                                {{method.isDefault ? 'Yes' : "No"}}
                            </td>
                            <td class="action">
                                <span *ngIf="selectedAccount.statusId !== 2" class="btnBars p-mr-0" pTooltip="Edit"
                                    tooltipPosition="top" (click)="editPayMethod(method)">
                                    <i class="pi pi-pencil"></i>
                                </span>
                                <ng-container *ngIf="selectedAccount.statusId !== 2">
                                    <span class="btnBars p-mr-0" *ngIf="!method?.isDefault" pTooltip="Delete"
                                        tooltipPosition="top" (click)="deletePayMethod(method,data)">
                                        <i class="pi pi-trash"></i>
                                    </span>
                                </ng-container>
                                <span class="btnBars p-mr-0" pTooltip="Relationship Access" *ngIf="hasChildAccounts"
                                    tooltipPosition="top" (click)="showRelationship(method.id)">
                                    <i class="pi pi-sitemap"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-divider class="y_padding" *ngIf="i !== accountPaymentMethodLists?.length - 1"></p-divider>
            </ng-container>
        </p-tabPanel>
        <p-tabPanel header="Payment Term">
            <p-table [value]="terms" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Is Active</th>
                        <th>Is Default</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-term>
                    <tr>
                        <td>{{term.paymentTerm?.name}}</td>
                        <td>{{term.statusId==1? 'Yes' : "No"}}</td>
                        <td>
                            <p-radioButton [disabled]="term.statusId==2 || selectedAccount.statusId ===2" [value]="true"
                                [(ngModel)]="term.isDefault"
                                (onClick)="makeDefault(term,terms,'paymentterm')"></p-radioButton>
                            {{term.isDefault ? 'Yes' : 'No'}}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td colspan="7" class="p-text-center">
                            No Data found.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Pricing" *ngIf="priceBookEnabled">
            <div class="p-d-flex p-jc-between">
                <h6 style="flex-grow:1">Price Tier <span class="p-ml-1">({{accountPriceTiers?.length ? accountPriceTiers?.length : 0}})</span></h6>
                <span *ngIf="selectedAccount?.statusId !=2" class="btnBars"
                    (click)="PricingMenu.toggle($event)">
                    <i class="pi pi-plus"></i>
                </span>
                <p-menu #PricingMenu [popup]="true" [model]="pricingItems" appendTo="body"></p-menu>
            </div>
            
            <p-table [value]="accountPriceTiers">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="p-col-6"> Name </th>
                        <th id="discount"> Markup/Discount </th>
                        <th id="action"> Action </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-tier let-i="rowIndex">
                    <tr>
                        <td> {{ tier.tierName }} </td>
                        <td> {{ tier.markUp }}%</td>
                        <td class="action">
                            <span *ngIf="selectedAccount.statusId !=2" class="btnBars p-mr-0"
                                (click)="editTierList(tier)" pTooltip="Edit" tooltipPosition="top">
                                <i class="pi pi-pencil"></i>
                            </span>
                            <span *ngIf="selectedAccount.statusId !=2" class="btnBars p-mr-0"
                                (click)="removeTier(tier.id,i,'tier')" pTooltip="Delete" tooltipPosition="top">
                                <i class="pi pi-trash"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr *ngIf="accountPriceTiers?.length">
                        <td colspan="12" class="p-text-center"> No Tier added. </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-divider class="y_padding"></p-divider>
            <h6>Group Discounts <span class="p-ml-1">({{accountPriceGroups?.length ? accountPriceGroups?.length :
                    0}})</span></h6>
            <p-table [value]="accountPriceGroups">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="p-col-6"> Name </th>
                        <th id="discount"> Markup/Discount </th>
                        <th id="action"> Action </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-group let-i="rowIndex">
                    <tr>
                        <td> {{ group.tierName }} </td>
                        <td> {{ group.markUp }}% </td>
                        <td class="action">
                            <span *ngIf="selectedAccount.statusId !=2" class="btnBars p-mr-0"
                                (click)="removeTier(group.id,i,'group')" pTooltip="Delete" tooltipPosition="top">
                                <i class="pi pi-trash"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr *ngIf="accountPriceGroups?.length">
                        <td colspan="12" class="p-text-center"> No Groups added. </td>
                    </tr>
                </ng-template>
            </p-table>
            <p-divider class="y_padding"></p-divider>
            <h6>Item Pricing <span class="p-ml-1">({{items?.length ? items?.length : 0}})</span></h6>
            <p-table [value]="items">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="item_name"> Item Name </th>
                        <th id="price_tier"> Price Tier </th>
                        <th id="price"> Price </th>
                        <th id="action"> Action </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <td> {{ product.itemNo }} </td>
                        <td> {{ product.tierName }} </td>
                        <td *ngIf="isEdit" class="action">
                            <input pInputText type="text" [(ngModel)]="product.price"
                                (ngModelChange)="displayAddButton()">
                        </td>
                        <td *ngIf="!isEdit"> {{ product.price }} </td>
                        <td class="action">
                            <span *ngIf="selectedAccount?.statusId !=2" class="btnBars p-mr-0" pTooltip="Edit"
                                tooltipPosition="top" (click)="isEdit=!isEdit">
                                <i class="pi pi-pencil"></i>
                            </span>
                            <span *ngIf="selectedAccount?.statusId !=2" class="btnBars p-mr-0"
                                (click)="removeTier(product.id,i,'item')" pTooltip="Delete" tooltipPosition="top">
                                <i class="pi pi-trash"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr *ngIf="items?.length">
                        <td colspan="12" class="p-text-center"> No Products added. </td>
                    </tr>
                </ng-template>
            </p-table>
            <div class="p-mt-2" *ngIf="showAddButton">
                <button type="button" pButton label="Save" (click)="updateAccountTierData(items)"></button>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Address">
            <ng-cointainer>
                <app-lion-address-grid *ngIf="selectedAccount?.accountAddresses" [allowEdit]="true"
                    [moduleId]="accountModuleId" [fieldLabels]="labels_address" [countries]="countries"
                    [contactListAttn]="contactListAttn" [checkedFields]="checkedFields"
                    [addressList]="selectedAccount.accountAddresses" [accountName]="selectedAccount?.businessName"
                    [selectedObjectRecord]="selectedAccount" [accountAddressTypes]="addressTypes"
                    [addressClasses]="addressClasses" mappingField="accountId"
                    (onUpdateAddressList)="onUpdateAddressList($event)" [overViewPage]="true">
                </app-lion-address-grid>
            </ng-cointainer>
        </p-tabPanel>
        <p-tabPanel header="Sub Accounts" *ngIf="selectedAccount?.hasChildAccounts">
            <p-table #childAccountsTable [value]="childAccounts" [columns]="savedDetailViewCols" selectionMode="single"
                [(selection)]="selectedChildAccount" (onRowSelect)="onChildAccountSelect()"
                (onRowUnselect)="selectedChildAccount = null" [totalRecords]="totalChildRecords" [paginator]="true"
                [rows]="15" [showCurrentPageReport]="true" styleClass="p-datatable-gridlines"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <ng-container *ngFor="let col of columns">
                            <col *ngIf="col?.enabled" style="width: auto">
                        </ng-container>
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col?.enabled" [pSortableColumn]="col.field">
                                {{col.name}}
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData">
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.enabled" style="text-align: left;"
                                [class.action-tag]="col.columnName =='tags'">
                                <ng-container *ngIf="!col?.depth; else depthTemplate">
                                    <ng-container *ngIf="col.columnName =='businessName'">
                                        <app-color-box class="colorBoxStyle" [color]="rowData.classificationColor">
                                        </app-color-box>
                                    </ng-container>
                                    <ng-container *ngIf="col.columnName =='tags'">
                                        <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                            <p-tag styleClass="p-ml-1" [value]="s?.name"
                                                [style]="{'background-color': s.color}"></p-tag>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="['twitter','website', 'facebook','linkedin','instagram',
                                                        'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                                        'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0;
                                                        else elseData">
                                        <a href="{{rowData[col.columnName] | url}}" target="_blank">{{
                                            rowData[col.columnName] | shorten }}</a>
                                    </ng-container>
                                    <ng-container *ngIf="phoneFields.includes(col.columnName)">
                                        {{ rowData[col.columnName] | phoneNumber: rowData[col.columnName+'code'] }}
                                    </ng-container>
                                    <ng-template #elseData>
                                        <ng-container
                                            *ngIf="col.columnName != 'tags' && !phoneFields.includes(col.columnName)">
                                            <ng-container [ngSwitch]="col?.fieldDataType">
                                                <ng-container *ngSwitchCase="'DateTime'">
                                                    {{ col?.isDateWithTime ? (rowData[col.columnName] |
                                                    localDate:'date') : (rowData[col.columnName] | date:'MM/dd/yyyy') }}
                                                </ng-container>
                                                <ng-container *ngSwitchDefault>
                                                    <span pTooltip="{{rowData[col.columnName]}}" tooltipPosition="top">
                                                        {{rowData[col.columnName] | shorten:27 }}
                                                    </span>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-template>
                                </ng-container>
                                <ng-template #depthTemplate>
                                    {{ rowData | columnName:col?.depth }}
                                </ng-template>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="12">
                            <p class="p-text-center">Loading Sub Accounts...</p>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Credit Limit" *ngIf="creditSetting">
            <div class="card">
                <form [formGroup]="creditForm">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6">
                            <label class="p-mr-3">Credit Control<span style="color: red;">*</span></label>
                            <p-dropdown [options]="creditOptions" optionLabel="name" appendTo="body"
                                [disabled]="selectedAccount.statusId == 2" formControlName="accountCreditControlId"
                                optionValue="code" (onChange)="editCredit(true)"></p-dropdown>
                        </div>
                    </div>

                    <div class="p-grid"
                        *ngIf="(hasChildAccounts) && creditForm.controls['accountCreditControlId'].value==creditControlStatic.On">
                        <div class="p-col-12 p-md-6">
                            <div class="p-field-radiobutton">
                                <p-radioButton [value]="creditTypeStatic.IndividualCredit"
                                    formControlName="creditTypeId" label="Parent Only"
                                    (click)="changeCreditTye(true,'Individual')"></p-radioButton>
                            </div>
                        </div>
                        <div class="p-col-12 p-md-6">
                            <div class="p-field-radiobutton">
                                <p-radioButton [value]="creditTypeStatic.ConsolidatedCredit"
                                    formControlName="creditTypeId" label="Both Parent & Child"
                                    (click)="changeCreditTye(true,'Consolidated')"></p-radioButton>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <ng-container
                *ngIf="creditForm.controls['accountCreditControlId'].value==creditControlStatic.On || creditForm.controls['accountCreditControlId'].value==creditControlStatic.Off">
                <p-table [value]="credits" responsiveLayout="scroll" dataKey="id">
                    <ng-template pTemplate="header">
                        <tr>
                            <th id="expand" style="width: 2rem"></th>
                            <th id="name">Name</th>
                            <th id="value">Value</th>
                            <th id="action"
                                *ngIf="creditForm.controls['accountCreditControlId'].value == creditControlStatic.On
                                && savedInventoryDetails?.parentControlTypeId==creditTypeStatic.IndividualCredit">
                                Action</th>
                            <!-- <th id="status">
                                    <ng-container *ngIf="selectedAccount.statusId != 2 && creditForm.controls['accountCreditControlId'].value == creditControlStatic.On">
                                        <p-inputSwitch [(ngModel)]="accountLevelCreditAvail" 
                                            (onChange)="editCredit(true)"></p-inputSwitch>
                                    </ng-container>
                                </th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-credit let-expanded="expanded">
                        <tr>
                            <td class="action">
                                <button type="button" pButton pRipple [pRowToggler]="credit"
                                    class="p-button-text p-button-rounded p-button-plain"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                    *ngIf="credit.children.length > 0"></button>
                            </td>
                            <td>{{credit.name}}</td>
                            <td>{{credit.value | number: "1.2-2" | currencySymbol}}</td>
                            <td class="action">
                                <span
                                    *ngIf="(savedInventoryDetails?.creditTypeId==creditTypeStatic.IndividualCredit || savedInventoryDetails?.parentControlTypeId==creditTypeStatic.IndividualCredit) && creditForm.controls['accountCreditControlId'].value == creditControlStatic.On && selectedAccount.statusId !=2"
                                    class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="editCredit()">
                                    <i class="pi pi-pencil"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <tr *ngFor="let child of product.children">
                            <td></td>
                            <td><span class="p-ml-3">{{child.name}}</span></td>
                            <td>{{child.value | number: "1.2-2" | currencySymbol}}</td>
                            <td></td>
                        </tr>
                    </ng-template>
                </p-table>
            </ng-container>
        </p-tabPanel>


        <!--- Dynamic Sub Tabs Start ---->

        <ng-container *ngFor="let subtabDetails of tabList; let i = index">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div (click)="selectSubTab(i)" class="p-d-flex p-ai-center custom-tab-name">
                        <span style="white-space: nowrap;">{{ subtabDetails?.widgetName }}</span>
                        <!-- <span class="pi pi-times widget-delete-icon" (click)="deleteSublist(subtabDetails)"></span> -->
                    </div>
                </ng-template>

                <ng-container [ngSwitch]="subtabDetails?.referenceTypeName">
                    <ng-container *ngSwitchCase="'SavedSearch'">
                        <app-saved-search-table-view *ngIf="activeSubtabIndex==i"
                            [savedSearchId]="subtabDetails.referenceId"
                            [tabWidgetDetails]="subtabDetails"
                            [showFlatTable]="true"
                            [isLeftTableHide]="isLeftTableHide"
                            [hideTableHeader]="true">
                        </app-saved-search-table-view>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Workbook'">
                        <app-shared-workbook-listing *ngIf="activeSubtabIndex==i"
                            [tabWidgetDetails]="subtabDetails"
                            [workbookIntId]="subtabDetails.referenceId"
                            [isLeftTableHide]="isLeftTableHide"
                            >
                        </app-shared-workbook-listing>
                    </ng-container>
                </ng-container>
            </p-tabPanel>
        </ng-container>
        
        <!--- Dynamic Sub Tabs End ---->
        <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
            <ng-template pTemplate="header">
                <ng-container *ngIf="selectedAccount.statusId !==2">
                    <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                        *ngIf="['Shipping','Payment Method','Payment Term'].includes(selectedTabHeader)"
                        (click)="openInventoryDialog()">
                        <i class="pi pi-pencil"></i>
                    </span>
                </ng-container>
            </ng-template>
        </p-tabPanel>
    </p-tabView>
    <p-dialog header="Payment Method" [(visible)]="displayAddPaymentMethod" [modal]="true" [responsive]="true"
        [style]="{width: '60vw'}" (onHide)="accountPaymethodForm.reset();addressInput=null;">
        <form [formGroup]="accountPaymethodForm">
            <div class="header p-d-flex p-jc-between">
                <h5 class="p-mb-0 w-100">Payment Method</h5>
                <p-inputSwitch formControlName="statusId"
                    [disabled]="savedAccountPayMethodDetails?.isDefault"></p-inputSwitch>
            </div>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-12 p-sm-6">
                        <label>Payment Method<span style="color: red;">*</span></label>
                        <p-dropdown [options]="inventoryForm?.controls['paymentMethods']?.value" placeholder="Select"
                            optionLabel="name" [showClear]="true" appendTo="body" [disabled]="!addFlag"
                            formControlName="paymentMethodId"
                            (onChange)="setDynamicFormValidation(accountPaymethodForm.controls['paymentMethodId'].value)"></p-dropdown>
                    </div>
                    <div class="p-col-12 p-sm-6"
                        *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name !== 'Credit Card' && accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name !== 'ACH'">
                        <label>Name<span style="color: red;">*</span></label>
                        <input type="text" pInputText formControlName="name">
                    </div>
                </div>
                <ng-container
                    *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'Credit Card'">
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>Card Holder Name<span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="accountName">
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>Phone No.</label>
                            <input type="text" pInputText formControlName="phoneNumber">
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12">
                            <label>Card No.<span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="accountNo" maxlength="16">
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>Expiration Date<span style="color: red;">*</span></label>
                            <p-calendar view="month" dateFormat="mm/yy" [readonlyInput]="true" inputId="monthpicker"
                                formControlName="expirationDate" [minDate]="minYear"></p-calendar>
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>CVV<span style="color: red;">*</span></label>
                            <input type="password" pInputText formControlName="cvv" maxlength="4" onlyNumber>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'ACH'">
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>Bank Name<span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="bankName">
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>Name on Account<span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="accountName">
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>Account No.<span style="color: red;">*</span></label>
                            <input type="text" pInputText formControlName="accountNo" maxlength="16">
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>Routing No.</label>
                            <input type="text" pInputText formControlName="routingNo" maxlength="16">
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'ACH' ||
                 accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'Credit Card'">
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label
                                *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'ACH'">Bank
                                Street</label>
                            <label
                                *ngIf="accountPaymethodForm?.controls['paymentMethodId'].value?.type?.name == 'Credit Card'">Street
                                1</label>
                            <lion-gm-place-autocomplete [formattedAddress]="addressInput"
                                (onRemoveAddress)="removeAddressLocation()"
                                (onAddressChange)="locationAddresChanged($event)"
                                (onSettingAddrress)="onAddressBlur($event)">
                            </lion-gm-place-autocomplete>
                            <small class="p-invalid">{{ ErrorMessageSetLocation }}</small>
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>Street 2 (Optional)</label>
                            <input type="text" pInputText formControlName="streetAddress2">
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>City</label>
                            <p-dropdown [options]="city" optionLabel="name" appendTo="body" placeholder="Select city"
                                formControlName="cityId"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>State</label>
                            <p-dropdown [options]="states" optionLabel="name" appendTo="body" formControlName="stateId"
                                (onChange)="getCitiesFromState($event.value)" placeholder="Select state"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-12 p-sm-6">
                            <label>Country</label>
                            <p-dropdown [options]="country" optionLabel="name" appendTo="body"
                                formControlName="countryId" placeholder="Select Country"
                                (onChange)="getStatesFromCountry($event.value)"></p-dropdown>
                        </div>
                        <div class="p-col-12 p-sm-6">
                            <label>Zipcode</label>
                            <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false"
                                formControlName="zipCode"></p-inputNumber>
                        </div>
                    </div>
                </ng-container>
            </div>
        </form>
        <p-footer>
            <button type="button" pButton (click)="displayAddPaymentMethod=false" label="Cancel"
                class="p-button-secondary"></button>
            <button type="button" pButton label="Save" [disabled]="!accountPaymethodForm?.valid"
                (click)="savePaymentMethod(accountPaymethodForm.value)"></button>
        </p-footer>
    </p-dialog>

    <p-dialog header="Shipping Method" [(visible)]="displayAddShippingMethod" [modal]="true" [responsive]="true"
        [style]="{width: '60vw'}">
        <div class="header p-d-flex p-jc-between">
            <h5 class="p-mb-0 w-100">Shipping Method</h5>
            <p-inputSwitch></p-inputSwitch>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-sm-6">
                    <label>Type</label>
                    <p-dropdown [options]="shippingMethods" placeholder="Select" optionLabel="name" [showClear]="true"
                        appendTo="body" [(ngModel)]="selectedSM"></p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-sm-6">
                    <label>Street 1</label>
                    <input type="text" pInputText>
                </div>
                <div class="p-col-12 p-sm-6">
                    <label>Street 2 (Option)</label>
                    <input type="text" pInputText>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-sm-6">
                    <label>City</label>
                    <p-dropdown [editable]="true" optionLabel="name"></p-dropdown>
                </div>
                <div class="p-col-12 p-sm-6">
                    <label>State</label>
                    <p-dropdown [editable]="true" optionLabel="name"></p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-sm-6">
                    <label>Country</label>
                    <p-dropdown [editable]="true" optionLabel="name"></p-dropdown>
                </div>
                <div class="p-col-12 p-sm-6">
                    <label>Zipcode</label>
                    <p-inputNumber mode="decimal" inputId="withoutgrouping" [useGrouping]="false"></p-inputNumber>
                </div>
            </div>
        </div>
        <p-footer>
            <button type="button" pButton (click)="displayAddShippingMethod=false" label="Cancel"
                class="p-button-secondary"></button>
            <button type="button" pButton label="Save"></button>
        </p-footer>
    </p-dialog>
</div>

<p-dialog header="Pricing Tiers" [(visible)]="displayTierList" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="card">
        <p-table [value]="allTiers" selectionMode="single" [(selection)]="selectedTier" dataKey="id">
            <ng-template pTemplate="header">
                <tr [pSelectableRow]="product">
                    <th id="name">Name</th>
                    <th id="discount">Markup/Discount(%)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tier let-rowIndex="rowIndex">
                <tr [pSelectableRow]="tier" [pSelectableRowIndex]="rowIndex">
                    <td>{{tier.name}}</td>
                    <td>
                        <span *ngIf="!tier.isCustom">{{tier.markup}}%</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayTierList = false;" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Add" [disabled]="!selectedTier || isDisabled" (click)="saveTier('tier')"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Pricing Tiers" [(visible)]="displayGroupList" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="card">
        <p-table [value]="tiersForGroup" selectionMode="multiple" [(selection)]="selectedGroups" dataKey="id">
            <ng-template pTemplate="header">
                <tr [pSelectableRow]="product">
                    <th id="name">Name</th>
                    <th id="discount">Markup/Discount(%)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group let-rowIndex="rowIndex">
                <tr [pSelectableRow]="group" [pSelectableRowIndex]="rowIndex">
                    <td>{{group.name}}</td>
                    <td>{{group.markup}}%</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayGroupList=false;" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Add" [disabled]="selectedGroups?.length==0 || isDisabled"
            (click)="saveTier('group')"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Item Pricing List" [(visible)]="displayItemList" [modal]="true" [responsive]="true"
    [style]="{width: '80vw'}" [closable]="false" (onHide)="isEdit=false;">
    <div class="card">
        <p-table #dt [value]="productData" dataKey="id" [paginator]="true" [totalRecords]="totalRecords"
            [rows]="pageSize" [showCurrentPageReport]="true" (onPage)="getData($event)" [lazy]="true" [paginator]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [first]=first>
            <ng-template pTemplate="caption">
                <div class="p-gird p-d-flex">
                    <div class="p-col-2">
                        <p-dropdown [options]="wareHouseList" optionLabel="customName" appendTo="body"
                            [(ngModel)]="selectedLocation" placeholder="Select Location"
                            (onChange)="productByCate()"></p-dropdown>
                    </div>
                    <div class="p-col-3">
                        <p-dropdown [options]="productChannels" [(ngModel)]="selectedTBChannel" optionLabel="name"
                            appendTo="body" (onChange)="onTypeChange()"></p-dropdown>
                    </div>
                    <div class="p-col-3">
                        <p-dropdown [options]="category" optionLabel="name" appendTo="body"
                            [(ngModel)]="selectedCategory" placeholder="Select Category"
                            (onChange)="productByCate()"></p-dropdown>
                    </div>
                    <div class="p-col-3">
                        <input pInputText type="text" (ngModelChange)="changed($event)" [(ngModel)]="searchValue"
                            placeholder="Search..." />
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th id="item no">Item No.</th>
                    <th id="item details">Item Details</th>
                    <th id="cost">Cost</th>
                    <th id="price tier">Price Tier</th>
                    <th id="sales price">Sale Price</th>
                    <th id="actions" class="action" style="width: 2rem;">
                        <span class="btnBars p-mr-0">
                            <i class="pi pi-pencil" (click)="isEdit = !isEdit"></i>
                        </span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <tr [pSelectableRow]="item" [pSelectableRowIndex]="rowIndex">
                    <td>{{item.itemNo}}</td>
                    <td>{{item.description | shorten: 55}}</td>
                    <td>{{item.cost}}</td>
                    <td *ngIf="!isEdit">
                        {{item.selectedTier?.name}}
                    </td>
                    <td *ngIf="isEdit" class="action">
                        <p-dropdown [options]="item.customTiers" placeholder="Select Tier" optionLabel="name"
                            appendTo="body" [(ngModel)]="item.selectedTier"
                            (onChange)="onChangeTier(item)"></p-dropdown>
                    </td>
                    <td *ngIf="!item.selectedTier">{{item.price}}</td>
                    <td pEditableColumn class="action" *ngIf="item.selectedTier">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="item.price"
                                    (ngModelChange)="onChangePrice(item)">
                            </ng-template>
                            <ng-template pTemplate="output">
                                ${{item.price | number: "1.2-2"}}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td class="action">
                        <p-checkbox [binary]="true" [(ngModel)]="item.isChecked" disabled></p-checkbox>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td colspan="10">
                        <div class="p-text-center">{{noProductsFindOrLoadingText}}</div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayItemList = false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Save" [disabled]="selectedItems?.length==0 || isDisabled"
            (click)="saveTier('customPrice')"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Account Details" *ngIf="displayAccountDetails" [(visible)]="displayAccountDetails" [modal]="true"
    [responsive]="true" [style]="{width: '60vw'}" [closable]="false" (onHide)="inventoryForm.reset()">
    <form [formGroup]="inventoryForm">
        <div class="header" *ngIf="isShipping">
            <h5>Shipping</h5>
        </div>
        <div class="card" *ngIf="isShipping">
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Shipping Methods</label>
                    <!-- <pre>{{shippingMethods | json}}</pre> -->
                    <!-- <p-multiSelect [options]="shippingMethodsDD" optionLabel="name" appendTo="body"
                        placeholder="Select Shipping Method" formControlName="shippingMethods"></p-multiSelect> -->
                    <!-- <p-treeSelect class="small" [options]="shippingMethodsDD" appendTo="body" formControlName="shippingMethods"  placeholder="Select Shipping Method"  [display]="'comma'"  [metaKeySelection]="'false'"  selectionMode="multiple" (onNodeSelect)="onShippingMethodSelected($event)"></p-treeSelect> -->
                    <p-treeSelect [options]="shippingMethodsDD" placeholder="Select Shipping Method" appendTo="body"
                        formControlName="shippingMethods" [metaKeySelection]="false" selectionMode="checkbox"
                        (onNodeSelect)="onShippingMethodSelected($event)"
                        (onNodeUnselect)="onShippingMethodUnselected($event)"></p-treeSelect>
                </div>
                <div class="p-col-6">
                    <label>Default Shipping Method</label>
                    <liono-treeSelect [options]="defaultShippingMethodsOptions" placeholder="Select a Shipping Method"
                        optionLabel="name" appendTo="body" formControlName="preferredShippingMethod"
                        optionDisabled="inactive" [metaKeySelection]="false"></liono-treeSelect>
                    <!-- <p-treeSelect  [options]="shippingMethodsDD" appendTo="body"  formControlName="preferredShippingMethod"  placeholder="Select a Shipping Method"></p-treeSelect> -->
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Shipping Terms</label>
                    <p-multiSelect [options]="shippingTermsDD" formControlName="shippingTerms" optionLabel="name"
                        appendTo="body" placeholder="Select Shipping Term"></p-multiSelect>
                </div>
                <div class="p-col-6">
                    <label>Default Shipping Term</label>
                    <p-dropdown [options]="inventoryForm?.controls['shippingTerms'].value"
                        placeholder="Select a Shipping Term" optionLabel="name" appendTo="body"
                        formControlName="preferredShippingTerm" optionDisabled="inactive"></p-dropdown>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-6">
                    <label>FOB Point</label>
                    <p-dropdown [options]="fobPoints" placeholder="Select FOB Point" optionLabel="name" appendTo="body"
                        formControlName="fobPoint"></p-dropdown>
                </div>
            </div>
        </div>
        <div class="header" *ngIf="isPaymentMethod || isPaymentTerm">
            <h5 *ngIf="isPaymentMethod">Payment Method</h5>
            <h5 *ngIf="isPaymentTerm">Payment Term</h5>
        </div>
        <div class="card">
            <div class="p-grid" *ngIf="isPaymentMethod">
                <div class="p-col-6">
                    <label>Payment Methods</label>
                    <p-multiSelect [options]="paymentMethods" formControlName="paymentMethods" optionLabel="name"
                        appendTo="body" placeholder="Select Payment Method"></p-multiSelect>
                </div>
                <div class="p-col-6">
                    <label>Default Payment Method</label>
                    <p-dropdown placeholder="Select a Payment Method"
                        [options]="inventoryForm?.controls['paymentMethods'].value" optionLabel="name" appendTo="body"
                        formControlName="preferredPaymentMethod"></p-dropdown>
                </div>
            </div>
            <div class="p-grid" *ngIf="isPaymentTerm">
                <div class="p-col-6">
                    <label>Payment Terms</label>
                    <p-multiSelect [options]="paymentTerms" formControlName="paymentTerms" optionLabel="name"
                        appendTo="body" placeholder="Select Payment Term"></p-multiSelect>
                </div>
                <div class="p-col-6">
                    <label>Default Payment Term</label>
                    <p-dropdown placeholder="Select a Payment Term"
                        [options]="inventoryForm?.controls['paymentTerms'].value" optionLabel="name" appendTo="body"
                        formControlName="preferredPaymentTerm"></p-dropdown>
                </div>
            </div>
            <!-- <div class="p-grid">
                <div class="p-col-6">
                    <label>Credit Limit</label>
                    <p-inputNumber formControlName="creditLimit" mode="decimal" [minFractionDigits]="2"
                        [maxFractionDigits]="2"></p-inputNumber>
                </div>

                <div class="p-col-6">
                    <label>Available Credit</label>
                    <p-inputNumber formControlName="availableCredit" mode="decimal" [min]="0" [minFractionDigits]="2"
                        [maxFractionDigits]="2" [readonly]="true"></p-inputNumber>
                </div>
            </div> -->
        </div>
    </form>

    <p-footer>
        <button type="button" pButton (click)="cancelShippingMethod()" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Save" (click)="saveInventoryDetails(inventoryForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Credit Limit Details" [(visible)]="displayCreditLimit" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="header">
        <h5>Credit Limit: {{creditForm?.controls['creditLimit']?.value}}</h5>
    </div>
    <div class="card">
        <form [formGroup]="creditForm">
            <!-- <div class="p-grid">
                <div class="p-col-2">
                    <label>Daily Max</label>
                </div>
                <div class="p-col-10">
                    <p-inputNumber class="small w-100" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="0"
                        formControlName="dailyMax" [maxFractionDigits]="2"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-2">
                    <label>Weekly Max</label>
                </div>
                <div class="p-col-10">
                    <p-inputNumber class="small w-100" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="0"
                        formControlName="weeklyMax" [maxFractionDigits]="2"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-2">
                    <label>Monthly Max</label>
                </div>
                <div class="p-col-10">
                    <p-inputNumber class="small w-100" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="0"
                        formControlName="monthlyMax" [maxFractionDigits]="2"></p-inputNumber>
                </div>
            </div> -->
            <div class="p-grid">
                <div class="p-col-2">
                    <label>New Credit Limit <span style="color: red;">*</span></label>
                </div>
                <div class="p-col-10">
                    <p-inputNumber class="small w-100" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="0"
                        formControlName="creditLimit" [maxFractionDigits]="2"></p-inputNumber>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayCreditLimit=false" label="Cancel"
            class="p-button-secondary"></button>
        <button type="button" pButton label="Save" [disabled]="!creditForm?.valid"
            (click)="saveCreditData(creditForm?.value)"></button>
    </p-footer>
</p-dialog>

<!-- Child Account Access -->
<app-account-relation-access [displayRelationship]="displayRelationship" [relationship]="childAccountRelations"
    (onClose)="onRelationClose()" (onSave)="saveRelation($event)"></app-account-relation-access>

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayAccountViewEdit" [displayEditViewDialog]="displayAccountViewEdit" [displayView]="true"
    [selectedAccountId]="selectedAccountId" (getAccountListAfterEdit)="loadChildAccounts()"
    (closeModal)="closeAccountViewEditModal()">
</app-edit-account>